var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoreVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 5,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 3.5c.962 0 1.75-.788 1.75-1.75C4.25.787 3.462 0 2.5 0S.75.787.75 1.75c0 .962.788 1.75 1.75 1.75Zm0 1.75C1.538 5.25.75 6.037.75 7s.788 1.75 1.75 1.75S4.25 7.963 4.25 7 3.462 5.25 2.5 5.25Zm0 5.25c-.962 0-1.75.787-1.75 1.75S1.538 14 2.5 14s1.75-.787 1.75-1.75-.788-1.75-1.75-1.75Z",
  fill: "#111"
})));
export default SvgMoreVertical;